import { render, staticRenderFns } from "./MeasuresSwiper.vue?vue&type=template&id=8702a758&scoped=true&"
import script from "./MeasuresSwiper.vue?vue&type=script&lang=js&"
export * from "./MeasuresSwiper.vue?vue&type=script&lang=js&"
import style0 from "./MeasuresSwiper.vue?vue&type=style&index=0&id=8702a758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8702a758",
  null
  
)

export default component.exports